module.exports = __webpack_public_path__ + "static/media/star.16b020b1.svg";